import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import {
  AppContainer,
  MainContentContainer,
  BodyContainer,
  QuestionBank,
} from '../../../resources/styling/appStyle';
import { SideMenu } from '../../../components/layouts/SideMenu';
import { Header } from '../../../components/layouts/Header';
import TagList from './components/TagList';
import '../../../resources/styling/App.scss';
import { AppButton } from '../../../resources/styling';
import { colors } from '../../../resources/theme/colors';
import AddEditSurvey from './components/AddEditSurvey';
import TemplateList from './components/TemplateList';

const { mandy, pictonBlue } = colors;

export default function SurveyTemplatesDashboard() {
  const [selectedTag, setSelectedTag] = React.useState(null);
  const [showAdd, setShowAdd] = React.useState(false);
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);

  const renderAddModal = () =>
    showAdd && (
      <AddEditSurvey
        doneEdit={setShowAdd}
        template={selectedTemplate}
        updateAfterEdit={setSelectedTemplate}
      />
    );

  return (
    <AppContainer>
      <SideMenu />
      <BodyContainer>
        <Header />
        <MainContentContainer>
          <Grid container mb={2}>
            <Grid item xs={6} lg={6} md={6} sm={6}>
              <h3>Insights Survey Templates</h3>
            </Grid>
            {!showAdd && (
              <Grid item xs={6} lg={6} md={6} sm={6} textAlign={'right'}>
                <AppButton
                  color={mandy}
                  onClick={() => {
                    setSelectedTemplate(null);
                    setShowAdd(true);
                  }}
                >
                  Add New Template
                </AppButton>
              </Grid>
            )}
          </Grid>
          <QuestionBank>
            {renderAddModal()}
            {!showAdd && (
              <Grid container spacing={0}>
                <Grid item xs={12} lg={3} md={3} sm={4}>
                  <TagList
                    selectedTag={selectedTag}
                    setSelectedTag={setSelectedTag}
                  />
                </Grid>

                <Grid item xs={12} lg={9} md={9} sm={8}>
                  <TemplateList
                    selectedTag={selectedTag}
                    selectedTemplate={selectedTemplate}
                    setSelectedTemplate={setSelectedTemplate}
                  ></TemplateList>
                </Grid>
              </Grid>
            )}
          </QuestionBank>
        </MainContentContainer>
      </BodyContainer>
    </AppContainer>
  );
}
